import { authenticatedFastApiAxiosInstanceAllowEmptyString } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import { type APIResponse } from "@/lib/types";
import { type MatterNoteComment } from "@/lib/types/Matter";

type AnnotationParentInput =
  | { matterId: string; massTortId?: never }
  | { matterId?: never; massTortId: string };

type CreateMatterNoteCommentInput = AnnotationParentInput &
  Pick<MatterNoteComment, "noteId" | "message" | "userId"> & {
    draft?: boolean;
  };

export const createMatterNoteCommentV1 = (
  data: CreateMatterNoteCommentInput,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<
      APIResponse<MatterNoteComment>
    >(`${baseFastApiMatterRoute}/notes/comments`, data)
    .then((res) => res.data);
};

type UpdateMatterNoteCommentInput = Pick<
  MatterNoteComment,
  "id" | "dateModified" | "noteId" | "message"
> &
  AnnotationParentInput;

export const updateMatterNoteCommentV1 = (
  data: UpdateMatterNoteCommentInput,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MatterNoteComment>
    >(`${baseFastApiMatterRoute}/notes/comments`, data)
    .then((res) => res.data);
};

export const deleteMatterNoteCommentV1 = (
  data: Pick<MatterNoteComment, "id" | "noteId"> & AnnotationParentInput,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .delete<
      APIResponse<MatterNoteComment>
    >(`${baseFastApiMatterRoute}/notes/comments/${id}`)
    .then((res) => res.data);
};
